import React from 'react';
export const LegendInPlanningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Light bulb icon - simplified and scaled to match other risk icons */}
    <g>
      <path
        d="M8.00039 1.79336C7.66914 1.79336 7.40039 1.52461 7.40039 1.19336V0.633203C7.40039 0.301955 7.66914 0.0332031 8.00039 0.0332031C8.33164 0.0332031 8.60039 0.301955 8.60039 0.633203V1.19336C8.60039 1.52461 8.33164 1.79336 8.00039 1.79336Z"
        fill="#292929"
      />
      <path
        d="M14.7637 8.01641H14.2035C13.8723 8.01641 13.6035 7.74765 13.6035 7.41641C13.6035 7.08516 13.8723 6.81641 14.2035 6.81641H14.7637C15.0949 6.81641 15.3637 7.08516 15.3637 7.41641C15.3637 7.74765 15.0949 8.01641 14.7637 8.01641Z"
        fill="#292929"
      />
      <path
        d="M1.78516 8.01641H1.225C0.893752 8.01641 0.625 7.74765 0.625 7.41641C0.625 7.08516 0.893752 6.81641 1.225 6.81641H1.78516C2.11641 6.81641 2.38516 7.08516 2.38516 7.41641C2.38516 7.74765 2.11641 8.01641 1.78516 8.01641Z"
        fill="#292929"
      />
      <path
        d="M3.60938 3.63126C3.45547 3.63126 3.30234 3.57267 3.18516 3.45547L2.78906 3.05938C2.55469 2.825 2.55469 2.44531 2.78906 2.21094C3.02344 1.97656 3.40313 1.97656 3.6375 2.21094L4.0336 2.60703C4.26798 2.84141 4.26798 3.2211 4.0336 3.45547C3.91642 3.57266 3.76328 3.63126 3.60938 3.63126Z"
        fill="#292929"
      />
      <path
        d="M12.3812 3.63126C12.2273 3.63126 12.0742 3.57267 11.957 3.45547C11.7227 3.2211 11.7227 2.84141 11.957 2.60703L12.3531 2.21094C12.5875 1.97656 12.9672 1.97656 13.2016 2.21094C13.4359 2.44531 13.4359 2.825 13.2016 3.05938L12.8055 3.45547C12.6883 3.57266 12.5352 3.63126 12.3812 3.63126Z"
        fill="#292929"
      />
      <path
        d="M12.7992 7.60078C12.7992 4.95391 10.6461 2.80078 7.99922 2.80078C5.35235 2.80078 3.19922 4.95391 3.19922 7.60078C3.19922 9.37334 4.16739 10.9207 5.60019 11.7519C5.60019 11.7538 5.59922 11.7553 5.59922 11.757V13.2008C5.59922 14.5242 6.67578 15.6008 7.99922 15.6008C9.32266 15.6008 10.3992 14.5242 10.3992 13.2008V11.7514C11.8315 10.9199 12.7992 9.37285 12.7992 7.60078ZM9.19922 13.2008C9.19922 13.8625 8.66094 14.4008 7.99922 14.4008C7.3375 14.4008 6.79922 13.8625 6.79922 13.2008V12.2428C7.18359 12.3423 7.58418 12.4008 7.99922 12.4008C8.41426 12.4008 8.81484 12.3423 9.19922 12.2428V13.2008ZM7.99922 11.2008C6.01406 11.2008 4.39922 9.58594 4.39922 7.60078C4.39922 5.61562 6.01406 4.00078 7.99922 4.00078C9.98438 4.00078 11.5992 5.61562 11.5992 7.60078C11.5992 9.58594 9.98438 11.2008 7.99922 11.2008Z"
        fill="#292929"
      />
    </g>
  </svg>
);
